import { GameListener, GameLogic } from 'game-logic';
import { RoundResultSubmitter } from './round-result-submitter';

export class LocalRoundResultSubmitter implements RoundResultSubmitter {
  private readonly gameListener: GameListener;

  constructor(gameListener: GameListener) {
    this.gameListener = gameListener;
  }

  public submitResult(game: GameLogic, isComplete: boolean): Promise<void> {
    const scoreData = game.generateScoreData();
    const commands = game.serializeCommandList();

    console.log(
      `game complete: ${isComplete} scoreData: ${JSON.stringify(
        scoreData,
      )}, commands: ${commands.join(',')}`,
    );

    this.gameListener.onGameComplete(commands, isComplete);

    return Promise.resolve();
  }
}
